import { useParams } from 'react-router-dom';

import TemplateApi from 'api/template';
import withAuthorizer from 'components/ui/withAuthorizer';
import TemplateHeader from 'components/templates/TemplateHeader';
import TemplateForm from 'components/templates/TemplateForm';
import withContentLoader from 'components/ui/withContentLoader';

import { Resources } from 'helpers/ResourceHelper';

const TemplatePage = ({ data }) => {
  const { templateId } = useParams();

  const fetchData = async () => TemplateApi.get(templateId);
  const Component = withContentLoader(
    ({ data }) => {
      return (
        <>
          <TemplateHeader data={data} />
          <div className="container mt-4">
            <div style={{ maxWidth: 700, margin: 'auto' }}>
              <TemplateForm data={data} />
            </div>
          </div>
        </>
      );
    },
    { name: ['template', templateId], fetchData }
  );

  return <Component />;
};

export default withAuthorizer(TemplatePage, [Resources.TEMPLATE_VIEW]);
